import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'AiServer',
            component: r => require.ensure([], () => r(require('@/pages/ai_server/main.vue')), 'AiServer')
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js